var TabPanelStyle = {};

export { TabPanelStyle as default };
